import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewRef } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { ApiService } from '../../../web-services/api/api.service';
import { ResponsiveService } from '../../../services/responsive.service';
import { ApiQuery } from '../../../web-services/api/api.query';

@Component({
  selector: 'app-site-config',
  imports: [TranslatePipe, RTLDivDirectiveDirective, MatDividerModule, MatGridListModule, RouterModule],
  templateUrl: './site-config.html',
  styleUrl: './site-config.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteConfig {
  siteObject: any[] = [];
  routeParamsSub;
	isMobile: boolean;
  siteId: any;
  private readonly destroy$ = new Subject<void>();

  constructor(private router: Router,private apiService:ApiService,private apiQuery:ApiQuery,private responsiveService: ResponsiveService,
		private route: ActivatedRoute, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
    this.apiQuery.sitesListData$.pipe(takeUntil(this.destroy$)).subscribe((sitesList) => {
      if(sitesList.length == 0) return;
      if(this.route.snapshot.paramMap.get("description") == "group"){
        this.siteId = this.route.snapshot.paramMap.get("id");
        const linkedSites = sitesList.filter(site => site['linked_sites_id'] == this.siteId);
        this.siteObject = linkedSites;
      }else{
        this.siteId = this.route.snapshot.paramMap.get("id");
        const site = sitesList.find(site => site['site_id'] == this.siteId);
        this.siteObject = [site];
      }
      this.cd.detectChanges();
    });     
  }

  onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

  ngOnDestroy() {    
    this.destroy$.next();
		this.destroy$.complete();
    if (!this.cd['destroyed'] || !(this.cd as ViewRef).destroyed) {			
			this.cd.detectChanges();
		}
  }

  openPreMapping() {
		if(this.siteObject.length > 1){
			this.router.navigate(['/preMapping/group', this.siteObject[0].linked_sites_id]);
		}else{
			this.router.navigate(['/preMapping/site', this.siteObject[0].site_id]);
		}
	}

  openSwapUnit() {
		if(this.siteObject.length > 1){
			this.router.navigate(['/swapUnit/group', this.siteObject[0].linked_sites_id]);
		}else{
			this.router.navigate(['/swapUnit/site', this.siteObject[0].site_id]);
		}
	}
}
